import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUserMd,
  FaNotesMedical,
  FaChartBar,
  FaMapMarkedAlt,
  FaCommentDots,
  FaHeadset,
  FaSignOutAlt
} from "react-icons/fa";
import "../CSS/SidebarTenagaKesehatan.css";

function SidebarTenagaKesehatan() {
  return (
    <div className="sidebar">
      <div className="logo-section">
        <img src="/assets/logobaruTibiSmart.png" alt="TibiSmart Logo" className="logo" />
      </div>

      <ul className="menusidebar">
        <li><NavLink to="/" activeclassname="active"><FaHome /> Home</NavLink></li>
        <li><NavLink to="/HalamanRingkasanAnalitikTK" activeclassname="active"><FaChartBar /> Analitik</NavLink></li>
        <li><NavLink to="/HalamanDataPasienTK" activeclassname="active"><FaNotesMedical /> Pasien</NavLink></li>
        <li><NavLink to="/HalamanPetaRisikoTenagaKesehatan" activeclassname="active"><FaMapMarkedAlt /> Peta Resiko</NavLink></li>
      </ul>

      <div className="bottom-menu">
        <li><NavLink to="/DetailTenagaKesehatanProfile" activeclassname="active"><FaUserMd /> Profile</NavLink></li>
        <li><NavLink to="/LaporKendalaTenagaKesehatan" activeclassname="active"><FaHeadset /> Support</NavLink></li>
        <li><NavLink to="/logout" activeclassname="active"><FaSignOutAlt /> Log Out</NavLink></li>
      </div>
    </div>
  );
}

export default SidebarTenagaKesehatan;
